__turbopack_context__.v({
  "emojiRow": "view-module__XESF4W__emojiRow",
});
